import gql from 'graphql-tag';

export default () => gql`
  query {
    getConfigIdd(dummy: "") {
      configIddList {
        value
        description
      }
    }
  }
`;
